// Robust section scrolling that cooperates with Lenis smooth scroll.
export function scrollToSection(href) {
  if (!href || !href.startsWith("#")) return;
  const el = document.querySelector(href);
  if (!el) return;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { offset: -80, duration: 1.2 });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: "smooth" });
  }
}
